import React from 'react';
import { contextIcons, defaultContextIcon } from './context-icons-data';

// Component to render a context icon
interface ContextIconProps {
  icon?: string;
  className?: string;
}

export function ContextIcon({ icon = defaultContextIcon, className = "w-5 h-5" }: ContextIconProps) {
  const IconComponent = contextIcons[icon] || contextIcons[defaultContextIcon];
  return <IconComponent className={className} />;
}